<template>
  <div class="powered-by-valt">
    <p class="powered-by-valt__label">Powered by</p>
    <a
      class="powered-by-valt__brand"
      href="https://valt.africa"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Valt — visit valt.africa"
    >
      <img src="/logo.png" alt="Valt" class="powered-by-valt__logo" />
    </a>
    <p class="powered-by-valt__tagline">Fleet Management System</p>
  </div>
</template>

<style scoped>
.powered-by-valt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  width: 100%;
  padding-top: 2.5rem;
  text-align: center;
}

.powered-by-valt__label {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--va-secondary, #6b7280);
}

.powered-by-valt__brand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.powered-by-valt__logo {
  max-height: 1.75rem;
  width: auto;
  object-fit: contain;
}

.powered-by-valt__tagline {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--va-secondary, #6b7280);
}
</style>
